import { render, staticRenderFns } from "./ProcedureSetting.vue?vue&type=template&id=449e1366"
import script from "./ProcedureSetting.vue?vue&type=script&lang=js"
export * from "./ProcedureSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports